<template>
  <div class="login container">
    <div v-if="!redeemCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <div v-else>
      <form @submit.prevent="$nextTick(submit)">

          <div class="d-flex justify-content-between">
          <div class="col-xs-6 pl-3 pt-5">
            <cta link="home" shape="circle" icon="left-arrow" text="" margin="no-margin" />
          </div>


          <div class="col-xs-6  pr-3 pt-5">
            <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="!card_reference || errors.has('card_reference')" margin="no-margin" :loading="submitted" />
          </div>
          </div>


          <div class="row">
          <h2 class="col-md-12 pt-2">Enter customer's card unique code</h2>
          </div>

          <div class="row d-flex justify-content-center">
          <div class="text-input-holder col-sm-12 pt-4 size-limit">
            <text-input :allowModelSet="true"  v-model="card_reference" placeholder="Enter unique code" name="card_reference" v-validate="'required'"  />
          </div>
          </div>

      </form>

      <div class="row">
        <div class="col-md-12">
          <qr-scanner @decode="onDecode" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){
      return {
        card_reference: '',
        submitted     : false
      };

  },
  created:function(){
    if(this.card.card_reference)
      this.card_reference = this.card.card_reference;
    
  },
  computed: {
    card()
    {
        return this.$store.getters.getCard;
    },
    accountId(){
        return this.$store.getters.getAccountId;
    }
  },
  methods:{
      /*
      * Decode QR code
      */
      onDecode(decodedString) {
          this.card_reference = decodedString;
      },
      /*
      * Login form submit handler
      */
      submit()
      {
    
          this.card_reference = this.card_reference.replace(/[^a-zA-Z0-9\s+\-.]/g, ''); 
        
          this.$validator.validateAll().then((result) => {
            if(result){

              this.submitted = true;

              window.axios({
                url: process.env.VUE_APP_API_GRAPH_URL,
                method: 'post',
                data: {
                  query: `
                    query($redeemable_at_account_id:Int!,$limit:Int!,$page:Int!,$card_reference:String!){
                              Cards(redeemable_at_account_id:$redeemable_at_account_id, card_reference:$card_reference, limit:$limit, page:$page){
                                data{
                                  id,
                                  card_reference,
                                  card_alias_card_reference,
                                  balance,
                                  Currency{symbol, denomination},
                                  product_name,
                                  Account{id}
                                }
                                total,
                                per_page
                              },
                          }
                        `,
                        variables: {
                          redeemable_at_account_id: this.accountId,
                          card_reference: this.card_reference,
                          page          : 1,
                          limit         : 1,
                        }
                }
              }).then((result) => {

                if(result.data.data && result.data.data.Cards.data.length){
                  this.$store.commit('SET_CARD', result.data.data.Cards.data[0]);
                  this.$router.push({ name: 'redeem-amount'});
                }else{
                  this.errors.add({field:'card_reference',msg:'Card not found'});
                }
              }).catch( () => {
                  this.$bus.$emit('error_message', 'Something went wrong, please try again!');
              }).then(() => {
                  this.submitted = false;
              });
              
            }
          });


      },

     


  }
}
</script>
